<template>
    <list-table
            :key="getTableKey"
            :columns="columns"
            :filters="filters"
            :pagination="true"
            :repository-func="repositoryFunc"
            :title="title"
            identifier="subscriptionsSkippedDatesTable"
            show-filters-immediately
    >

        <template v-slot:destination-template="{ row }">
            <div class="font-bold text-sm mb-1">
                {{ row.fullName }}
            </div>
            <div class="text-xs">
                <p>{{ row.street }}, {{ row.postalCode }} {{ row.city }},
                    {{ row.country | toCountryNameString }}</p>
            </div>
        </template>
        <template v-slot:product-ids-template="{ row }">
            <div>
                <span v-for="(item) in row.items" :key="item.productId" >
                  <product-quick-action-modal :id="item.productId" />
                </span>
            </div>
        </template>


        <template v-slot:member-quick-action-template="{ row }">
            <member-quick-action-modal :id="row.memberId"/>
        </template>

        <template v-slot:subscription-quick-action-template="{ row }">
            <subscription-quick-action-modal :subscription-id="row.subscriptionId"/>
        </template>
    </list-table>
</template>

<script>
import ListTable from "@/components/listTable/ListTable";
import MemberQuickActionModal from "@/components/pages/Members/Subcomponents/MemberQuickActionModal";

import SubscriptionRepository from "@/repositories/SubscriptionRepository";
import ProductQuickActionModal from "@/components/pages/Products/Subcomponents/ProductQuickActionModal.vue";
import SubscriptionQuickActionModal
    from "@/components/pages/Subscription/Subcomponents/SubscriptionQuickActionModal.vue";
import {FILTER_DATETIME_RANGE} from "@/components/listTable/includes/controls/filters/availableFilters";

export default {
    name: "ShowSkipDates",
    components: {
        SubscriptionQuickActionModal,
        ProductQuickActionModal,
        MemberQuickActionModal,
        ListTable
    },
    computed: {
        // used as a workaround to render the table again when switching from a shortcut (today's orders, tomorrows order, ...) to the regular page,
        getTableKey() {
            return this.$route.name + '_' + Math.random();
        }
    },
    data: function () {
        return {
            title: 'Dates sautées',
            repositoryFunc: SubscriptionRepository.getSkippedDatesPaginated,
            filters: [
                {
                    caption: "Abbon. ID(s)",
                    filterKey: "subscriptionIds",
                    forceIsVisible: true
                },
                {
                    caption: "ID(s) ou Nom Membre",
                    filterKey: "memberIdsOrName",
                    forceIsVisible: true,
                },
                {
                    caption: "Period sautées",
                    filterKey: "skippedPeriod",
                    type: FILTER_DATETIME_RANGE,
                    forceIsVisible: true
                },
            ],
            columns: [
                {
                    caption: '#',
                    cellTemplate: 'subscription-quick-action-template',
                    sort: {
                        dataField: 'subscriptionId',
                        default: 'desc'
                    }
                },
                {
                    caption: 'Mem',
                    cellTemplate: 'member-quick-action-template'
                },
                {
                    caption: 'Nom Client',
                    dataField: 'fullName',
                },
                {
                    caption: 'Date sautée',
                    calculateCellValue: (r) => this.$date(r.date).format('DD.MM.YY'),
                    sort: {
                        dataField: 'skippedDate',
                        default: 'desc'
                    },
                    visible: true
                },
            ]
        }
    },
}
</script>

